import { Routes, Route, Navigate } from 'react-router-dom'

import Stock from 'Pages/stock'
import AIFocus from 'Pages/aifocus'
import AISignal from 'Pages/aisignal'

const Router = () => {
  return (
    <Routes>
  <Route path="/stock" element={<Stock />} />
  <Route path="/aifocus" element={<AIFocus />} />
  <Route path="/aisignal" element={<AISignal />} />
      <Route path="/" element={<Navigate to="/stock" replace />} />
    </Routes>
  );
};

export default Router
